"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateStyled = exports.TitleStyled = exports.TextContainer = exports.LineStyled = exports.CircleStyled = exports.GraphContainer = exports.EventContainer = exports.TimeLineStyled = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../styles/widths");

var _palette = require("../../../styles/palette");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

var TimeLineStyled = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", " {\n    width: 100%;\n  }\n  ", " {\n    flex-direction: column;\n  }\n"])), _widths.mediaQueries.desktop, _widths.mediaQueries.notDesktop);

exports.TimeLineStyled = TimeLineStyled;
TimeLineStyled.displayName = 'TimeLineStyled';

var EventContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", " {\n    flex-direction: column;\n    width: 100%;\n  }\n"])), _widths.mediaQueries.desktop);

exports.EventContainer = EventContainer;
EventContainer.displayName = 'EventContainer';

var GraphContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  ", " {\n    width: 100%;\n  }\n  ", " {\n    flex-direction: column\n  }\n"])), _widths.mediaQueries.desktop, _widths.mediaQueries.notDesktop);

exports.GraphContainer = GraphContainer;
GraphContainer.displayName = 'GraphContainer';

var CircleStyled = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius: 100%;\n  width: ", "px;\n  height: ", "px;\n  background: ", ";\n  border: 2px solid ", ";\n"])), _widths.widths.base * 3, _widths.widths.base * 3, function (_ref) {
  var serviceCanceled = _ref.serviceCanceled,
      withIncidence = _ref.withIncidence,
      completed = _ref.completed;
  return !completed ? 'transparent' : serviceCanceled ? _palette.palette.disabled : withIncidence ? _palette.palette.warning : _palette.palette.link;
}, function (_ref2) {
  var serviceCanceled = _ref2.serviceCanceled,
      withIncidence = _ref2.withIncidence,
      completed = _ref2.completed;
  return serviceCanceled || !completed ? _palette.palette.disabled : withIncidence ? _palette.palette.warning : _palette.palette.link;
});

exports.CircleStyled = CircleStyled;
CircleStyled.displayName = 'CircleStyled';

var LineStyled = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  background: ", ";\n  flex: 1;\n  ", " {\n    height: 2px;\n  }\n  ", " {\n    width: 2px;\n    min-height: 35px;\n  }  \n"])), function (_ref3) {
  var nextIsCompleted = _ref3.nextIsCompleted,
      serviceCanceled = _ref3.serviceCanceled;
  return nextIsCompleted && !serviceCanceled ? _palette.palette.link : _palette.palette.disabled;
}, _widths.mediaQueries.desktop, _widths.mediaQueries.notDesktop);

exports.LineStyled = LineStyled;
LineStyled.displayName = 'LineStyled';

var TextContainer = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  ", " {\n    margin-left: ", "px;\n  }  \n"])), _widths.mediaQueries.notDesktop, _widths.widths.base * 2);

exports.TextContainer = TextContainer;
TextContainer.displayName = 'TextContainer';

var TitleStyled = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  text-transform: capitalize;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", "px;\n  line-height: ", "px;\n  color: ", ";\n  ", " {\n    margin-top: ", "px;\n  }\n"])), _widths.font, _widths.font.semi, _widths.widths.base * 2, _widths.widths.base * 3, function (_ref4) {
  var completed = _ref4.completed,
      serviceCanceled = _ref4.serviceCanceled;
  return completed && !serviceCanceled ? _palette.palette.bobBlack : _palette.palette.disabled;
}, _widths.mediaQueries.desktop, _widths.widths.base);

exports.TitleStyled = TitleStyled;
TitleStyled.displayName = 'TitleStyled';

var DateStyled = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 12px;\n  color: ", ";\n  line-height: ", "px;\n"])), _widths.font, _widths.font.regular, function (_ref5) {
  var serviceCanceled = _ref5.serviceCanceled;
  return serviceCanceled ? _palette.palette.disabled : _palette.palette.grey;
}, _widths.widths.base * 2);

exports.DateStyled = DateStyled;
DateStyled.displayName = 'DateStyled';